const ticksPerSecond = 10000000;

/**
 * @param {number} ticks
 * @param {object} doctorLocation
 * @returns {string}
 */
export default function getTimeslotId(ticks, doctorLocation) {
    const profId = doctorLocation.professional.professional_id;
    const locId = doctorLocation.location.location_id;
    const adServedEventId = doctorLocation.ad_served_event_id;
    const adServedEventIdPostfix = !!adServedEventId ? `-${adServedEventId}` : '';

    return `${ticks / ticksPerSecond}-${profId}-${locId}${adServedEventIdPostfix}`;
}
